import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: 'https://srm-backend-628d.onrender.com/api',  // Render.com deployed backend
  headers: {
    'Content-Type': 'application/json'
  }
});

// Client API methods
export const clientApi = {
  // Get all clients
  getAll: async () => {
    try {
      const response = await api.get('/clients');
      return response.data;
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  },

  // Get client by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching client ${id}:`, error);
      throw error;
    }
  },

  // Create new client
  create: async (clientData) => {
    try {
      const response = await api.post('/clients', clientData);
      return response.data;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },

  // Update client
  update: async (id, clientData) => {
    try {
      const response = await api.put(`/clients/${id}`, clientData);
      return response.data;
    } catch (error) {
      console.error(`Error updating client ${id}:`, error);
      throw error;
    }
  },

  // Delete client
  delete: async (id) => {
    try {
      console.log(`Sending DELETE request to /clients/${id}`);
      // Make sure id is properly converted to a string if it's a number
      const clientId = id.toString();
      const response = await api.delete(`/clients/${clientId}`);
      console.log('Delete API response:', response);
      return response.data;
    } catch (error) {
      console.error(`Error deleting client ${id}:`, error);
      console.error('Response data:', error.response?.data);
      throw error;
    }
  },
  
  // Bulk upload clients from CSV data
  bulkUpload: async (clientsData) => {
    try {
      const response = await api.post('/clients/bulk', clientsData);
      return response.data;
    } catch (error) {
      console.error('Error uploading clients in bulk:', error);
      throw error;
    }
  }
};

export default api;
